import React from 'react'

export default function SolutionProjects() {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 2V24C2 26.8003 2 28.2003 2.54497 29.27C3.02433 30.2108 3.78925 30.9757 4.73005 31.455C5.79962 32 7.19975 32 10 32H32M30.3347 22H23.668M18.668 8.6667H8.66794M27.0013 15.3333H12.0013" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
